module.exports = __webpack_public_path__ + "static/img/wa02.1ee50f6e.png";